import { Controller } from "@hotwired/stimulus"

// カスタムSlideoverコントローラー
// 注意: このコントローラーは現在使用されていません。
// application.jsで直接tailwindcss-stimulus-componentsのSlideoverを使用しています。
export default class extends Controller {
  static targets = ["slideover", "overlay"]

  connect() {
    console.log("[Stimulus] Custom Slideover controller connected")
    console.log("[Stimulus] Note: This controller is not being used. Using tailwindcss-stimulus-components instead.")
  }

  // メニューを開く
  open(event) {
    if (event) event.preventDefault()
    
    // Slideoverを表示
    this.slideoverTarget.classList.remove("-translate-x-full")
    this.slideoverTarget.classList.add("translate-x-0")
    
    // オーバーレイを表示
    this.overlayTarget.classList.remove("hidden")
    
    console.log("[Stimulus] Slideover opened")
  }

  // メニューを閉じる
  close(event) {
    if (event) event.preventDefault()
    
    // Slideoverを非表示
    this.slideoverTarget.classList.remove("translate-x-0")
    this.slideoverTarget.classList.add("-translate-x-full")
    
    // オーバーレイを非表示
    this.overlayTarget.classList.add("hidden")
    
    console.log("[Stimulus] Slideover closed")
  }
}
